export default function initLazySentry() {
  const DSN = process.env.SENTRY_DSN;
  if (DSN) {
    import(/* webpackChunkName: "sentry" */ '@3ui/dev-sentry').then(
      ({ init }) => {
        init({ dsn: DSN });
      }
    );
  }
}
